import { useState } from 'react';
import './style.css';
export const Slider = () => {
  const [cerrar, setCerrar] = useState(true);
  return (
    <div className='background-area video-area'>
      <video
        src='Promo-FINTEC.mp4'
        autoPlay
        muted
        loop
        style={{ width: '100%' }}
      ></video>
      {cerrar && (
        <div className='cookie-banner-conteiner'>
          <a className='boton-cerrar ' onClick={() => setCerrar(false)}>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='16'
              height='16'
              fill='currentColor'
              class='bi bi-x'
              viewBox='0 0 16 16'
            >
              <path d='M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z' />
            </svg>
          </a>
          <img src='/img/FINTEC2.png' alt='' className='cookie6' />
          <img src='/img/robot1.png' alt='' className='cookie1' />
          <img src='/img/cohete.png' alt='' className='cookie2' />
          <img src='/img/robot2.png' alt='' className='cookie3' />
          <img src='/img/libro.png' alt='' className='cookie4' />
          <img src='/img/robot3.png' alt='' className='cookie5' />
          <img src='/img/lcss.png' alt='' className='cookie7' />
          <h3 className='title'>FINTEC II</h3>
          <p className='cookie-info'>
            {' '}
            2do Foro de Innovación y Tecnología Educativa <br />
            Fecha: 28 y 29 de septiembre de 2023
            <br />
            Sede: CRESON, Hermosillo, Sonora.
            <br />
            ACCESO LIBRE
          </p>
          <a href='http://fintecii.creson.edu.mx/' className='confirm-button'>
            VAMOS
          </a>
        </div>
      )}
    </div>
  );
};
